import styled from "styled-components";
import {Person, Profile, StyledBaseProps} from "@betrue/shared/interfaces";
import {
  Avatar,
  Card,
  CardActionArea,
  CardContent,
  CardHeader,
  Dialog,
  DialogContent,
  Grid,
  Typography
} from "@material-ui/core";
import {SkillTag} from "@betrue/ui";

import randomColor from 'randomcolor';
import {useState} from "react";
import {personAvatarUrl} from "@betrue/front/services";

export interface PublicProfileCardViewProps extends StyledBaseProps {
  profile: Profile
  person: Person
}

export const PublicProfileCardViewHeight = '300px'
export const PublicProfileCardView = styled((props: PublicProfileCardViewProps) => {
  const [open, setOpen] = useState(false)

  const onCardClick = () => {
    setOpen(!open)
  }
  return (<div className={props.className}>
      <Card className={'bt-profile-card'}>
        <CardActionArea className={'bt-profile-card-action'}
                        onClick={() => onCardClick()}>
          <div  className={'bt-card-header'} style={{backgroundColor: randomColor({ format: 'rgba', alpha: 0.15})}}/>
          <CardContent>
            <Grid container direction={"column"} alignItems={'center'} alignContent={'center'}>

              <Grid item className={'bt-avatar-container'}>
                <Avatar aria-label="recipe" className={'bt-avatar'} src={personAvatarUrl(props.person)}>
                  {
                    props.person.firstName ?
                      props.person.firstName[0] :
                      '??'
                  }
                </Avatar>
              </Grid>
              <Grid item style={{textAlign: 'center'}}>
                <Typography component={'h3'} variant={'h4'} className={'bt-profile-firstname'}>
                  {props.person.firstName}
                </Typography>
                <Typography component={'p'} style={{textAlign: 'center'}}>
                  {props.profile.job?.label ? props.profile.job?.label : '...'}
                </Typography>
              </Grid>
            </Grid>
          </CardContent>
        </CardActionArea>

      </Card>
      <Dialog
        onClose={onCardClick}
        disableAutoFocus={true}
        disableEnforceFocus={true}
        disableRestoreFocus={true}
        disablePortal={true}
        open={open}>
        <DialogContent style={{padding: 0, fontSize: '12px'}}>

          <CardHeader
            className='card-header'
            avatar={
              <Avatar aria-label="recipe" className={'avatar'} src={personAvatarUrl(props.person)}>
                {
                  props.person.firstName ?
                    props.person.firstName[0] :
                    '??'
                }
              </Avatar>
            }
            title={`${props.person.firstName}`}
            subheader={`${props.profile.job?.label ? props.profile.job?.label : ''} `}
          />

          <CardContent>
            <Grid container direction={"row"} spacing={1}>
              <Grid item>
                <Grid container direction={"row"} spacing={0}>
                  <Grid item style={{minWidth: '0'}}>
                    <p>{props.profile.description ? props.profile.description : ' '}</p>

                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container direction={"row"} spacing={0}>
                  {props.profile.skills.map((profileSkill) => (
                    <Grid item key={profileSkill.id} className='skill-item'>
                      <SkillTag skill={profileSkill.skill}/>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </CardContent>
        </DialogContent>
      </Dialog>
    </div>

  )
})`

  & {


    .bt-profile-card-action {
      height: 100%;
    }

    .bt-profile-firstname {
      padding-top: 10px;
      text-transform: capitalize;
      font-weight: bold;
      color: ${props =>  props.theme.colors.accent};
    }

    .bt-card-header {
      position: absolute;
      top: 0;
      height: 150px;
      width: 100%;
      background-size: cover;
    }
    .bt-profile-skills {
      height: 70px;
      overflow: hidden;
    }

    .bt-profile-description {
      flex: 1 1 auto;
      width: 100%;
      height: 65px;
      text-overflow: ellipsis;
      overflow: hidden;
    }

    .bt-avatar-container {

      .bt-avatar {
        text-transform: uppercase;
        width: 150px;
        height: 150px;
      }
    }
    .bt-profile-card {
      height: ${PublicProfileCardViewHeight};
    }


    .card-skill-content {
      font-size: 13px;
      overflow: hidden;
    }

    .bt-badge {
      margin-right: 30px;
    }

    .bt-badge span {
      background-color: ${props => props.theme.colors.accent};
      color: #FFF;
    }

    .card-header {
      padding-bottom: 0;
      text-transform: capitalize;
    }
  }
`
